import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { InputField } from "../InputField/InputField";
import { Logo } from "../Logo/Logo";

import textConstants from "./textConstants";
import { Keyboard } from "@playwright/test";

import { Heading1, ParagraphBody1, ParagraphBody2, CustomInputField, PrimaryButton, Title1 } from "ts-widgets";

export const LoginFromDetails = ({ setEmail, email, mutate, isLoading, isEmailSent, setIsEmailSent }: any) => {
    const [emailFromUrl, setEmailFromUrl] = useState("");

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const location = useLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const SOCIAL_LOGIN: string = process.env.SOCIAL_LOGIN || "";

    useEffect(() => {
        if (urlParams) {
            const value = urlParams.get("emailId");
            if (value) {
                setEmailFromUrl(value);
                setEmail(value);
            }
        }

        const handleEnterKey = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                onContinue();
            }
        };

        window.addEventListener("keydown", handleEnterKey);

        return () => {
            window.removeEventListener("keydown", handleEnterKey);
        };
    }, [urlParams, email]);

    const isValidEmail = (email: string) => {
        console.log("SOCIAL_LOGIN", SOCIAL_LOGIN);
        if (SOCIAL_LOGIN && SOCIAL_LOGIN === "enabled") {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const validMail = emailPattern.test(email);
            const emailRegexPattern =
                "^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!live.com)(?!tempmail.net)(?!guerrillamail.com)(?!outlook.com)(?!icloud.com)(?!protonmail.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$";
            const emailRegex = new RegExp(emailRegexPattern);
            const validMailWithSocial = emailRegex.test(email);
            if (!validMail) {
                setError("Invalid email, Try valid email");
            }
            if (!validMailWithSocial) {
                setError("Personal email not allowed, Try work email");
            }
            return validMail && validMailWithSocial;
        } else {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const IsValidTest = emailPattern.test(email);
            if (!IsValidTest) {
                setError("Invalid email, Try valid email");
            }
            return IsValidTest;
        }
    };
    const onContinue = () => {
        setIsEmailSent(false);
        if (isValidEmail(email)) {
            mutate(email);
        }
    };
    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            onContinue();
        }
    };

    const onChangeMail = (value: any) => {
        setEmail(value);
    };

    return (
        <div className="flex grow flex-col px-12 h-full justify-between gap-8 items-center relative p-8 md:p-0 bg-[#F8FAFC]">
            <div className="flex flex-col justify-center items-center gap-8 w-full h-full md:w-[380px]">
                {!isEmailSent && (
                    <div
                        className={`flex flex-col justify-center items-center w-[380px] "h-[344px]"  p-[43px] rounded-xl bg-white transition-all duration-300 shadow-[0px_0px_24px_0px_rgba(15, 23, 42, 0.04)]`}>
                        <Logo />

                        <div className={`flex flex-col w-[254px]`}>
                            <InputField
                                disabled={emailFromUrl}
                                value={email}
                                onChange={onChangeMail}
                                label={"Work email"}
                                placeholder={"e.g. name@workemail.com"}
                                fieldId={"email"}
                                isFirstStage={true}
                                isTooltip={false}
                            />
                            <button
                                type="button"
                                onClick={onContinue}
                                onKeyPress={handleKeyPress}
                                className="w-full h-[48px] flex justify-center items-center gap-2 py-[10px] px-6 text-[16px] leading-[22px] disabled:bg-[#E0E3FB] bg-[#273BE2] text-white disabled:text-white cursor-pointer disabled:cursor-default rounded-lg"
                                disabled={isLoading}>
                                {isLoading && (
                                    <svg
                                        className="animate-spin h-5 w-5 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24">
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                )}
                                <span className={isLoading ? "flex-1" : ""}>
                                    {isLoading ? "Sending Email..." : textConstants.LOGIN}
                                </span>
                            </button>
                            <span className="mb-[20px] mt-[20px] text-sm">
                                Don't have an account?{" "}
                                <a onClick={() => navigate("/auth/sign-up")} className="cursor-pointer text-[#0525f5]">
                                    Create an account
                                </a>
                            </span>
                        </div>
                    </div>
                )}

                {isEmailSent && (
                    <div
                        className={`flex flex-col justify-center items-center w-[380px] "h-[344px]"  p-[43px] rounded-xl bg-white transition-all duration-300 shadow-[0px_0px_24px_0px_rgba(15, 23, 42, 0.04)]`}>
                        <div className="flex flex-col gap-2">
                            <Title1 className="tracking-tight text-center" label={textConstants.EMAIL_SENT_TITLE} />
                            <ParagraphBody2
                                className="text-center mb-2"
                                label={
                                    <>
                                        Check <span className="font-semibold">{email}</span> to verify your email and
                                        get started.
                                    </>
                                }
                            />
                            <ParagraphBody2
                                className="text-center"
                                label="Check spam if not in your inbox. Verification link expires in 3 minutes."
                            />
                        </div>
                        <div className="flex flex-col gap-4">
                            {/* #TODO: Need auth0 config to enable code along with the magic link */}
                            {/* <Button
                                type="default"
                                // onClick={onContinue}
                            >
                                {textConstants.EMAIL_SEND_CODE_MANUALLY_CTA}
                            </Button> */}
                            {/* <Button type="default" onClick={onContinue}>
                                {textConstants.EMAIL_SEND_BACK_TO_LOGIN_CTA}
                            </Button> */}
                        </div>
                        <p className="text-gray-400 p-8 text-sm text-center">
                            {textConstants.NEED_HELP} &nbsp;
                            <a href="#" className="hover:text-purple-600 text-purple-500">
                                {textConstants.CONTACT_SUPPORT}
                            </a>
                        </p>
                    </div>
                )}
            </div>
            <p className="text-gray-400 p-8 pb-0 text-sm ">
                {textConstants.FOOTER_TEXT}
                <a href="#" className="hover:text-purple-600">
                    Terms of Service {""}
                </a>
                and {""}
                <a href="" className="hover:text-purple-600">
                    Privacy Policy
                </a>
            </p>
        </div>
    );
};
